'use strict';

function getInnerText(el) {
  return el.textContent || el.innerText || '';
}

module.exports = getInnerText;


/** WEBPACK FOOTER **
 ** ./utils/getInnerText.js
 **/